<template>
  <div class="home">
    <tabs-app></tabs-app>
    <dropdown></dropdown>
    <div class="tongbu">
      <coursetongbu></coursetongbu>
    </div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import tabbar from "@/components/Tabbar";
import tabsApp from "@/components/tabsApp";
import dropdown from "@/components/dropdown";
import coursetongbu from "@/components/CourseTongbu";
export default {
  components: {
    tabbar,
    tabsApp,
    dropdown,
    coursetongbu
  },
  data() {
    return {
      iteminfo:''
    };
  },
  mounted() {
    this.getuser()
  },
  methods:{
    // 个人信息
    getuser(){
      this.$axios({
        method: "post",
        url: 'https://api.rujiaowang.net/index.php/api/user/get_user',
        data: {
          token:localStorage.getItem('token'),
        },
      }).then(res =>{
        this.iteminfo = res.data.result
        localStorage.setItem('info',JSON.stringify(this.iteminfo))
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.van-tabs--line /deep/ .van-tabs__wrap {
  height: 40px;
}
.van-tabs /deep/ .van-tabs__line {
  background-color: #1989fa;
}
</style>

<style scoped>
.tabs {
  width: 100%;
  height: 100%;
  background-color: #eee;
}
.title {
  display: none !important;
}
.neirong {
  margin-top: 100px;
}
.tongbu {
  margin-top: 100px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/course/course.vue